import React from 'react';
import { Panel, Grid, Row, Col } from 'rsuite';
import HomeIntroSteps from './HomeIntroSteps';
import TopKubonds from './TopKubonds';

import { useTranslation } from 'react-i18next';

const GettingStarted = () => {
  const { t } = useTranslation();

  return (
    <Panel style={{ textAlign: 'center', justifyContent: 'center' }}>
      <h1>{t('greeting')}</h1>
      <p>{t('gettingStarted.instruction')}</p>
      <br />
      <HomeIntroSteps />
      {/* <Grid fluid>
        <Row className="show-grid">
          <Col xs={24} sm={24} md={8}>
            <h4>{t('gettingStarted.kyc.heading')}</h4>
            <br />
            <img src="/kyc.png" width="400" height="240" />
            <br />
            <p>
              <br />
              {t('gettingStarted.kyc.content')}{' '}
              <a href="https://example.com">here</a>.
            </p>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <h4>{t('gettingStarted.metamask.heading')}</h4>
            <br />
            <img src="/wallet.png" width="420" height="240" />
            <br />
            <p>
              <br /> {t('gettingStarted.metamask.content.1')}{' '}
              <a href="https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=enMetamask">
                metamask
              </a>{' '}
              {t('gettingStarted.metamask.content.2')}{' '}
              <a href="https://chrome.google.com/webstore/detail/coinbase-wallet-extension/hnfanknocfeofbddgcijnmhnfnkdnaad?hl=en">
                Coinbase
              </a>{' '}
              {t('gettingStarted.metamask.content.3')}
              <br />
            </p>
          </Col>

          <Col xs={24} sm={24} md={8}>
            <h4> {t('gettingStarted.matic.heading')}</h4>
            <br />
            <img src="/matic.jpeg" width="400" height="240" />
            <br />
            <p>
              <br /> {t('gettingStarted.matic.content')}
            </p>
          </Col>
        </Row>
      </Grid> */}
    </Panel>
  );
};

export default GettingStarted;
